import http from "@/settings/apiSettings"

class AtributeService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_Atribute", data)
    }
}
export default new AtributeService()